module.exports = __webpack_public_path__ + "img/00—03b—Password recovery.133400d2.jpg";